export default __webpack_public_path__ + "static/monotype-helvetica-display-medium-74dc5532c9df04b7490232247b89f8da.woff2";